import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

import RoleSettings from "@/components/settings/RoleSettings.vue";
import PlannerGroupSettings from "@/components/settings/PlannerGroupSettings.vue";
import CostCenterSettings from "@/components/settings/CostCentreSettings.vue";
import AssetClassSettings from "@/components/settings/AssetClassSettings.vue";
import { useFilterStore } from "@/store/filter";
import { ref } from "vue";

type Tab = (typeof tabs)[number];


export default /*#__PURE__*/_defineComponent({
  __name: 'settings',
  setup(__props) {

const filters = useFilterStore();
filters.hide();

const tabs = [
  "roles",
  "planner-groups",
  "cost-centers",
  "asset-classes",
] as const;
const currentTab = ref<Tab>(tabs[0]);

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_toolbar, {
      color: "grey-lighten-3",
      density: "compact"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tabs, {
          modelValue: currentTab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentTab).value = $event))
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
              return _createVNode(_component_v_tab, {
                key: tab,
                text: tab,
                value: tab
              }, null, 8, ["text", "value"])
            }), 64))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_tabs_window, { "model-value": currentTab.value }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tabs_window_item, { value: "roles" }, {
          default: _withCtx(() => [
            _createVNode(RoleSettings)
          ]),
          _: 1
        }),
        _createVNode(_component_v_tabs_window_item, { value: "planner-groups" }, {
          default: _withCtx(() => [
            _createVNode(PlannerGroupSettings)
          ]),
          _: 1
        }),
        _createVNode(_component_v_tabs_window_item, { value: "cost-centers" }, {
          default: _withCtx(() => [
            _createVNode(CostCenterSettings)
          ]),
          _: 1
        }),
        _createVNode(_component_v_tabs_window_item, { value: "asset-classes" }, {
          default: _withCtx(() => [
            _createVNode(AssetClassSettings)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})